export const RIDE_TYPES = {
  shadow: "Shadow",
  request: "Request",
  commute: "Commute",
};

export const RIDE_TYPES_RENDER = {
  shadow: "Empty Vehicle",
  request: "Request",
  commute: "Commute",
};



// WEBPACK FOOTER //
// ./src/utils/constants.js